import { IFraction } from "../../services/Entities";
import { ICanvasRenderOptions, IDraw2D } from "../abstraction/IDraw2D";
import { IViewLayer } from "../abstraction/IViewLayer";

export class TimeDraw implements IDraw2D {

    protected _layer: IViewLayer;

    constructor() {

    }

    attach(layer: IViewLayer) {
        this._layer = layer;
    }

    draw2D(ctx: CanvasRenderingContext2D, options: ICanvasRenderOptions) {

        if (!this.bpm || !this.tempo)
            return;


        const beatTime = 1 / (this.bpm / 60);

        let curTime = Math.ceil(options.viewRect.x / beatTime) * beatTime;

        let curBeat = curTime / beatTime;

        const beatTimePx = beatTime * options.viewScale.x;

        let curTimePx = (curTime - options.viewRect.x) * options.viewScale.x;

        while (curTimePx < this._layer.host.margin.x) {
            curTimePx += beatTimePx;
            curBeat++;
        }
  
        ctx.save();

        ctx.resetTransform();

        ctx.font = (13 * window.devicePixelRatio) + "px Arial";
        ctx.fillStyle = "#999";

        ctx.clearRect(0, 0, options.viewSize.width, this._layer.host.margin.y);

        ctx.beginPath();

        while (curTimePx < options.viewSize.width) {

            if (curBeat % this.tempo.num == 0) {
                ctx.moveTo(curTimePx, 30);
                ctx.lineTo(curTimePx, options.viewSize.height);
            }

            const textSize = ctx.measureText(curBeat.toString());

            ctx.fillText(curBeat.toString(), curTimePx - textSize.width / 2, textSize.actualBoundingBoxAscent + 2);

            this._layer.host.margin.y = Math.min(this._layer.host.margin.y, 42 + textSize.actualBoundingBoxAscent)

            curTimePx += beatTimePx;
            curBeat++;
        }

        ctx.lineWidth = 2;
        ctx.strokeStyle = "#AAA";
        ctx.stroke();

        ctx.restore();
    }

    bpm: number;

    tempo: IFraction;
}